/**
 * @tutorial https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/from
 * @see https://github.com/lodash/lodash/blob/master/.internal/setToArray.js
 * ^ could use if needed
 */
module.exports = Array.from
